const inMemoryFetchTranslation = ({ translationData }) => async ({ locale }) => new Promise((resolve) => setTimeout(() => resolve(translationData[locale]), 3000));
export { inMemoryFetchTranslation };
